import { isFeatureEnabled } from 'owa-feature-flags';
import ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { lazyGetSmimeViewStateForResponse } from 'owa-smime';
import { isBrowserSupported } from 'owa-smime-adapter/lib/utils/smimeUtils';
import SmimeViewState from 'owa-smime/lib/store/schema/SmimeViewState';
import isSMIMEItem from 'owa-smime/lib/utils/isSMIMEItem';
import isSmimeSupportedForItem from 'owa-smime/lib/utils/isSmimeSupportedForItem';
import {
    isSmimeAdminSettingEnabled,
    isSmimeUserSettingEnabled,
} from 'owa-smime/lib/utils/smimeSettingsUtil';

/**
 * This util returns the SmimeViewState for the new response
 * respecting both Admin/User S/MIME settings.
 *
 * @param parentItem Item for which we are responding currently.
 * @param isReply is Reply/Reply All
 */
const tryGetSmimeViewStateForResponse = async (
    parentItem: ClientItem,
    isReply: boolean
): Promise<SmimeViewState> => {
    /**
     * S/MIME response is not allowed when
     * 1. Browser is supported for S/MIME
     * 2. UserOptions.AlwaysShowFrom is enabled in user settings
     * 3. Parent Item class doesn't support S/MIME
     */
    if (
        isFeatureEnabled('cmp-smime') &&
        isBrowserSupported() &&
        !getUserConfiguration().UserOptions.AlwaysShowFrom &&
        isSmimeSupportedForItem(parentItem, isReply) &&
        (isSmimeAdminSettingEnabled() || isSmimeUserSettingEnabled() || isSMIMEItem(parentItem))
    ) {
        return await (await lazyGetSmimeViewStateForResponse.import())(parentItem);
    }

    return null;
};

export default tryGetSmimeViewStateForResponse;
